import { createFileRoute } from '@tanstack/react-router'
import { ReportDetailView } from '@/components/report-detail-view'
import { Skeleton } from '@/components/ui/skeleton'
import { useReport, usePropertyReports } from '@/hooks/use-property-queries'
import { AlertCircle } from 'lucide-react'

export const Route = createFileRoute('/dashboard/land-monitoring/$propertyId/$reportId')({
    component: ReportDetailPage,
})

function ReportDetailPage() {
    const { propertyId, reportId } = Route.useParams()

    // For 'latest', we fetch all reports for property and take first
    const { data: reports, isLoading: isReportsLoading } = usePropertyReports(propertyId)
    const { data: specificReport, isLoading: isReportLoading } = useReport(reportId === 'latest' ? '' : reportId)

    const isLoading = reportId === 'latest' ? isReportsLoading : isReportLoading

    // Find report
    const report = reportId === 'latest'
        ? (reports || []).sort((a, b) => b.visitDate.localeCompare(a.visitDate))[0]
        : specificReport

    if (isLoading) {
        return (
            <div className="space-y-6">
                <Skeleton className="h-10 w-[400px] rounded-xl" />
                <Skeleton className="h-[200px] w-full rounded-2xl" />
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <Skeleton className="h-[300px] w-full rounded-2xl" />
                    <Skeleton className="h-[300px] w-full rounded-2xl" />
                    <Skeleton className="h-[300px] w-full rounded-2xl" />
                </div>
            </div>
        )
    }

    if (!report) {
        return (
            <div className="flex flex-col items-center justify-center py-20 bg-destructive/5 rounded-2xl border border-destructive/10">
                <AlertCircle className="h-12 w-12 text-destructive mb-4" />
                <p className="text-lg font-bold text-destructive">Report not found</p>
                <p className="text-sm text-destructive/60 mt-1">The requested inspection report could not be located.</p>
            </div>
        )
    }

    return <ReportDetailView report={report} />
}
